export const LIST_CONTACT_REQ = "LIST_CONTACT_REQ";
export const LIST_CONTACT_SUCCESS = "LIST_CONTACT_SUCCESS";
export const LIST_CONTACT_FAILED = "LIST_CONTACT_FAILED";

export const LIST_CONTACT_SINGLE_DATA_REQ = "LIST_CONTACT_SINGLE_DATA_REQ";
export const LIST_CONTACT_SINGLE_DATA_SUCCESS =
  "LIST_CONTACT_SINGLE_DATA_SUCCESS";
export const LIST_CONTACT_SINGLE_DATA_FAILED = "LIST_CONTACT_SINGLE_DATA_FAILED";
export const LIST_CONTACT_SINGLE_DATA_RESET = "LIST_CONTACT_SINGLE_DATA_RESET";

export const CREATE_CONTACT_REQ = "CREATE_CONTACT_REQ";
export const CREATE_CONTACT_SUCCESS = "CREATE_CONTACT_SUCCESS";
export const CREATE_CONTACT_FAILED = "CREATE_CONTACT_FAILED";
export const CREATE_CONTACT_RESET = "CREATE_CONTACT_RESET";

export const UPDATE_CONTACT_REQ = "UPDATE_CONTACT_REQ";
export const UPDATE_CONTACT_SUCCESS = "UPDATE_CONTACT_SUCCESS";
export const UPDATE_CONTACT_FAILED = "UPDATE_CONTACT_FAILED";
export const UPDATE_CONTACT_RESET = "UPDATE_CONTACT_RESET";

export const DELETE_CONTACT_REQ = "DELETE_CONTACT_REQ";
export const DELETE_CONTACT_SUCCESS = "DELETE_CONTACT_SUCCESS";
export const DELETE_CONTACT_FAILED = "DELETE_CONTACT_FAILED";
export const DELETE_CONTACT_RESET = "DELETE_CONTACT_RESET";

export const CONTACT_LIST_BY_COURSE_ID_REQ='CONTACT_LIST_BY_COURSE_ID_REQ';
export const CONTACT_LIST_BY_COURSE_ID_SUCCESS='CONTACT_LIST_BY_COURSE_ID_SUCCESS';
export const CONTACT_LIST_BY_COURSE_ID_FAILED='CONTACT_LIST_BY_COURSE_ID_FAILED';
export const CONTACT_LIST_BY_COURSE_ID_RESET='CONTACT_LIST_BY_COURSE_ID_RESET';
